<app-auth-form
  [isRegister]="isRegister"
  [errorMessage]="errorMessage"
  [loading]="isLoading"
  (formSubmit)="onLogin($event)"
  (cancelMFA)="cancelMFA()"
  [loginExtra]="devLoginVisible ? devLoginTpl : null"
></app-auth-form>

<ng-template #devLoginTpl>
  <div class="dev-login">
    <button type="button" class="dev-login-toggle" (click)="toggleDevLogin()">dev login</button>

    @if (devLoginOpen) {
      <div class="dev-login-menu">
        @if (devLoginLoading && devLoginUsers.length === 0) {
          <div class="dev-login-state">{{ 'auth.login.dev.loadingUsers' | transloco }}</div>
        }

        @if (!devLoginLoading && devLoginUsers.length === 0) {
          <div class="dev-login-state">{{ 'auth.login.dev.noUsers' | transloco }}</div>
        }

        @for (user of devLoginUsers; track user.id) {
          <button
            type="button"
            class="dev-login-user"
            [disabled]="devLoginLoading"
            (click)="forceDevLogin(user.id)"
          >
            <span class="dev-login-name">{{ user.name }}</span>
            <span class="dev-login-email">{{ user.email }}</span>
            <span class="dev-login-roles">{{ user.role }}</span>
          </button>
        }
      </div>
    }
  </div>
</ng-template>
